import { OilTransportationTypeBase } from './base/oil-transportation-type-base';

export class OilTransportationType extends OilTransportationTypeBase { }